var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { commonCssStyles } from "../../global-styles.js";
import { classMap } from "lit/directives/class-map.js";
/**
 * Exposes a shadow part calls `linkcontainer` that allows the consumer apply new styles
 * for the selector link container
 */
let LanguageSelectorLink = class LanguageSelectorLink extends LitElement {
    constructor() {
        super(...arguments);
        this.selected = false;
    }
    focus(options) {
        this.shadowRoot.getElementById("language-option-btn").focus(options);
    }
    render() {
        return html `<button
      id="language-option-btn"
      part="linkcontainer"
      class="container ${classMap({
            selected: this.selected,
        })}"
      type="button"
      role="option"
      aria-labelledby="displayName"
      aria-selected="${this.selected}"
    >
      <div class="label text-body-s-regular" id="displayName">
        ${this.displayName}
      </div>
      <svg
        class="checkmark"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.59375 10.625C7.25 10.9688 6.71875 10.9688 6.375 10.625L4.375 8.625C4.03125 8.28125 4.03125 7.75 4.375 7.40625C4.71875 7.0625 5.25 7.0625 5.59375 7.40625L7 8.78125L10.375 5.40625C10.7188 5.0625 11.25 5.0625 11.5938 5.40625C11.9375 5.75 11.9375 6.28125 11.5938 6.625L7.59375 10.625ZM16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0C12.4062 0 16 3.59375 16 8ZM8 1.5C4.40625 1.5 1.5 4.4375 1.5 8C1.5 11.5938 4.40625 14.5 8 14.5C11.5625 14.5 14.5 11.5938 14.5 8C14.5 4.4375 11.5625 1.5 8 1.5Z"
        />
      </svg>
    </button>`;
    }
};
LanguageSelectorLink.styles = [
    commonCssStyles,
    css `
      .container {
        background-color: transparent;
        list-style: none;
        display: flex;
        height: 40px;
        min-width: 150px;
        width: 100%;
        outline: none;
        border: 2px solid transparent;
        padding: 10px;
        align-items: center;
        gap: 16px;
        box-sizing: border-box;
        transition: var(--delay-transition75);
      }

      .container .label {
        color: var(--text-text-weak-color);
        display: flex;
        align-items: center;
        flex: 1 0 0;
        transition: var(--delay-transition75);
      }

      .container .checkmark {
        display: none;
        justify-content: center;
        align-items: center;
        width: 16px;
        height: 16px;
        fill: var(--button-success);
        transition: var(--delay-transition75);
      }

      .container:hover {
        cursor: pointer;
        background-color: var(--tones-lavender10-color);
      }

      .container:hover .label {
        color: var(--text-text-color);
      }

      .container:hover .checkmark {
        fill: var(--dark-gray-color);
      }

      .container.selected .checkmark {
        display: flex;
      }

      .container:focus-visible {
        border: 2px solid var(--tones-lavender50-color);
      }

      .container:focus-visible .label {
        color: var(--text-text-color);
      }
    `,
];
__decorate([
    property()
], LanguageSelectorLink.prototype, "displayName", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], LanguageSelectorLink.prototype, "selected", void 0);
LanguageSelectorLink = __decorate([
    customElement("language-selector-link")
], LanguageSelectorLink);
export { LanguageSelectorLink };
